// extracted by mini-css-extract-plugin
export default {"root":"DeviceChartTitle_root__XeT5U"};